import React from 'react';

/**
 * Template 8: Question + Arrow
 * Dark bg, subject on right, short provocative question left in large serif,
 * curved arrow pointing to subject.
 *
 * Inspired by: "How was this allowed?", "see ya!"
 */
export default function V_QuestionArrow({
  headline = 'How was this allowed?',
  subjectImage,
  bgColor = '#000000',
  accentColor = '#E53935',
}) {
  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: bgColor, fontFamily: "'Playfair Display', serif",
    }}>
      {/* Subject image - right side */}
      {subjectImage ? (
        <div style={{
          position: 'absolute', right: 0, top: 0, width: 700, height: 720,
          zIndex: 1,
        }}>
          <img src={subjectImage} alt="" style={{
            width: '100%', height: '100%', objectFit: 'cover',
          }} />
          {/* Dark gradient from left for text readability */}
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(90deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 40%, transparent 70%)',
          }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', right: 60, top: '50%', transform: 'translateY(-50%)',
          width: 480, height: 440, background: 'rgba(255,255,255,0.05)',
          borderRadius: 12, zIndex: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 32, color: 'rgba(255,255,255,0.12)',
        }}>SUBJECT</div>
      )}

      {/* Question text - left side */}
      <h1 style={{
        position: 'absolute', top: 100, left: 60,
        margin: 0, fontSize: 96, fontWeight: 700, lineHeight: 1.1,
        color: '#FFFFFF', zIndex: 2,
        maxWidth: 580,
        textShadow: '0 4px 20px rgba(0,0,0,0.8)',
      }}>
        {headline}
      </h1>

      {/* Curved arrow pointing right */}
      <svg style={{
        position: 'absolute', left: 120, bottom: 140,
        width: 120, height: 80, zIndex: 3,
      }} viewBox="0 0 120 80">
        <path
          d="M 10 60 Q 60 0, 110 40"
          fill="none" stroke="white" strokeWidth="4"
          strokeLinecap="round"
        />
        <polygon points="105,30 115,42 100,45" fill="white" />
      </svg>
    </div>
  );
}
